// Check descriptions arrive as HTML in the result JSON. Keep only simple text markup and http(s) links.
const ALLOWED_TAGS = new Set(['A', 'B', 'BR', 'CODE', 'EM', 'I', 'LI', 'OL', 'P', 'STRONG', 'UL'])

const clean = (node) => {
  for (const child of [...node.childNodes]) {
    if (child.nodeType === Node.TEXT_NODE) continue
    if (child.nodeType !== Node.ELEMENT_NODE) {
      child.remove()
      continue
    }
    clean(child)
    if (!ALLOWED_TAGS.has(child.tagName)) {
      child.replaceWith(...child.childNodes)
      continue
    }
    const href = child.tagName === 'A' ? child.getAttribute('href') : null
    for (const attribute of [...child.attributes]) {
      child.removeAttribute(attribute.name)
    }
    if (href && /^https?:\/\//i.test(href)) {
      child.setAttribute('href', href)
      child.setAttribute('target', '_blank')
      child.setAttribute('rel', 'noopener')
    }
  }
}

export default function sanitiseHtml (html) {
  const body = new DOMParser().parseFromString(String(html ?? ''), 'text/html').body
  clean(body)
  return body.innerHTML
}
